__turbopack_context__.v({
  "root": "BaseToggle-module__-dhzHq__root",
});
